import React, { useState, useEffect } from "react";
import { Modal, Button, Input, Icon, Label } from "semantic-ui-react";
import { DELIVERY_CHANNELS } from "../../../../utils/constants";
import "./DeliveryModal.scss";

// "Registra tu delivery" (como Restaurant.pe): canal por el que llegó el
// pedido y costo de envío, al abrir una mesa virtual de tipo Delivery. El
// envío se suma a la cuenta; el canal alimenta "Por canal de venta".
export function DeliveryModal(props) {
  const { show, title = "Delivery", initialChannel = "", initialFee = null, onCancel, onConfirm } =
    props;
  const [channel, setChannel] = useState("");
  const [fee, setFee] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setChannel(initialChannel || "");
      setFee(initialFee != null ? String(Number(initialFee)) : "");
      setSaving(false);
    }
  }, [show, initialChannel, initialFee]);

  const feeNumber = fee === "" ? 0 : Number(fee);
  const valid = !!channel && !Number.isNaN(feeNumber) && feeNumber >= 0;

  const confirm = async () => {
    if (!valid) return;
    setSaving(true);
    try {
      await onConfirm(channel, feeNumber.toFixed(2));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={show} size="tiny" onClose={onCancel} className="delivery-modal">
      <Modal.Content>
        <h3 className="delivery-modal__title">{title}</h3>
        <p className="delivery-modal__label">Selecciona un canal</p>
        <div className="delivery-modal__channels">
          {DELIVERY_CHANNELS.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`delivery-modal__channel${
                channel === option.value ? " delivery-modal__channel--active" : ""
              }`}
              onClick={() => setChannel(option.value)}
            >
              <Icon name={option.icon} />
              {option.text}
            </button>
          ))}
        </div>
        <p className="delivery-modal__label">Costo de envío</p>
        <Input labelPosition="left" type="number" min="0" step="0.50" placeholder="0.00" value={fee}
          onChange={(_, data) => setFee(data.value)}>
          <Label basic>S/</Label>
          <input />
        </Input>
      </Modal.Content>
      <div className="delivery-modal__actions">
        <Button type="button" basic onClick={onCancel}>
          <Icon name="close" /> Cancelar
        </Button>
        <Button type="button" primary disabled={!valid || saving} loading={saving} onClick={confirm}>
          <Icon name="check" /> Siguiente
        </Button>
      </div>
    </Modal>
  );
}
